import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export const PrivateRouter = ({ children }) => {

    const { email } = useSelector((state) => state.auth);

    // hola mundo
    return email !== '' ? children : <Navigate to={"/auth"}> </Navigate>

};
